const initFont = () => {
    var element = document.createElement('style');
    document.head.appendChild(element);
    var sheet = element.sheet;
    var styles = '@font-face { font-family: "Rockridge"; src: url("Rockridge.ttf") format("truetype"); }\n';
    sheet.insertRule(styles, 0);
    var styles2 = '@font-face { font-family: "Comfortaa"; src: url("Comfortaa-VariableFont_wght.ttf") format("truetype"); }\n';
    sheet.insertRule(styles2, 0);



}

const onFontInit = (fonts, callback) => {
    WebFont.load({
        custom: {
            families: fonts
        },
        active: callback
    });
}

export { initFont, onFontInit }